module.exports = "/_next/static/images/show-60ac252928a7729ce6019ab4dfca11c4.svg";